import { keyframes } from '@emotion/core';
import { CommonProps, Flex } from '@modusign/design-system';
import { HTMLAttributes } from 'react';

interface OverlayProps extends CommonProps, Omit<HTMLAttributes<HTMLDivElement>, 'color'> {}

const OVERLAY_ZINDEX = 900;

const overlayAnimation = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

function Overlay(props: OverlayProps) {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      {...props}
      sx={{
        animationDuration: '0.2s',
        animationName: overlayAnimation,
        backgroundColor: 'rgba(0,0,0,0.6)',
        height: '100%',
        left: 0,
        overflow: 'auto',
        padding: 0,
        position: 'fixed',
        top: 0,
        width: '100%',
        zIndex: OVERLAY_ZINDEX,
      }}
    />
  );
}

export default Overlay;
